export default function (e) {
    return e > 1099511627776 ?
        (e/1024/1024/1024/1024).toFixed(2) + ' TB' :
            e > 1073741824 ?
                (e/1024/1024/1024).toFixed(2) + ' GB' :
                    e > 1048576 ?
                        (e/1024/1024).toFixed(2) + ' MB' :
                            e > 1024 ?
                                (e/1024).toFixed(2) + ' KB':
                                e.toString() + ' B'
}
